import Styled from './SectionTitle.styled';

interface Props {
  text: string;
}

function SectionTitle({ text }: Props) {
  return <Styled.Root>{text}</Styled.Root>;
}

export default SectionTitle;
